import { ComponentConfig } from "@measured/puck";

import ColorPickerField, { ColorPickerFieldProps } from "src/components/Puck/config/fields/ColorPickerField";
import RichTextEditorField from "src/components/Puck/config/fields/RichTextEditorField";
import type { RichTextEditorFieldProps } from "src/components/Puck/config/fields/RichTextEditorField";
import { CombinedProps, Typography as PuckTypography, TypographyProps } from "./Typography";
import { allTypographyVariants } from "@foodpilot/foods";
import { TEXT_SPACING_OPTIONS } from "src/components/Puck/config/layoutTokens";

export const Typography: ComponentConfig<TypographyProps> = {
    fields: {
        align: {
            type: "radio",
            label: "Text alignment",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
            ],
        },
        content: {
            type: "custom",
            label: "Content",
            render: (props: RichTextEditorFieldProps) => (
                <RichTextEditorField {...props} label="Content" enableTokenSuggestions={false} />
            ),
        },
        linkUrl: {
            type: "text",
            label: "Link URL",
        },
        variant: {
            type: "select",
            label: "Text variant",
            options: allTypographyVariants.map((variant) => ({
                label: variant,
                value: variant,
            })),
        },

        color: {
            type: "custom",
            label: "Text color",
            render: (props: ColorPickerFieldProps) => <ColorPickerField {...props} />,
        },
        spacing: {
            type: "select",
            label: "Vertical spacing",
            options: TEXT_SPACING_OPTIONS,
        },
    },
    defaultProps: {
        variant: "body",
        align: "left",
        color: "#000000",
        content: "Enter your text here",
        gutterBottom: true,
        noWrap: false,
        linkUrl: null,
        spacing: "default",
    },
    render: (props: CombinedProps) => <PuckTypography {...props} />,
};
